<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong v-if="status_form==0">ثبت محصول</strong>
                        <strong v-if="status_form!=0">ویرایش محصول</strong>
                        <div class="card-header-actions">
                            <a
                                    href="https://coreui.io/vue/docs/components/form-components"
                                    class="card-header-action"
                                    rel="noreferrer noopener"
                                    target="_blank"
                            >
                                <small class="text-muted"></small>
                            </a>
                        </div>
                    </CCardHeader>
                    <CCardBody>
                        <CRow>
                            <CCol sm="4">
                                <CInput
                                        v-model="title"

                                        label="عنوان اصلی محصول فارسی"
                                        placeholder="عنوان"
                                        vertical
                                />
                            </CCol>

                            <CCol sm="4">
                                <CInput
                                        v-model="seo_title"

                                        label="عنوان اصلی محصول لاتین"

                                />

                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                        label="برند محصول"
                                        :options="brand_items"
                                        :value.sync="selected_brand"/>
                            </CCol>
                            <CCol sm="4">
                                <label>دسته بندی محصول</label>
                                <div class="control_wrapper">
                                    <treeselect
                                            v-model="value_category"
                                            :multiple="true"
                                            :normalizer="normalizer_category"

                                            :options="options_category"
                                            placeholder="دسته بندی محصول را انتخاب کنید"
                                    />

                                </div>

                            </CCol>
                            <CCol sm="4">
                                <CInput
                                        v-model="code"
                                        label="کد محصول"
                                        placeholder="کد"
                                />
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                        label="رنگ محصول"
                                        :options="colors_items"
                                        :value.sync="selected_color"/>
                            </CCol>

                            <CCol sm="4">
                                <CInput
                                        label="آدرس جایگزین"
                                        v-model="favorite_url"/>
                            </CCol>
                            <CCol sm="4">
                                <CInput
                                        label="موجودی"
                                        v-model="existence"/>
                            </CCol>
                            <CCol sm="4">
                                <CInput
                                        label="گارانتی به ماه"
                                        v-model="warranty"
                                description="0 به معنی بدون گارانتی میباشد"/>
                            </CCol>

                        </CRow>
                        <CRow>

                        </CRow>
                        <CRow>
                            توضیحات کوتاه

                            <CCol sm="12">
                                <ckeditor
                                        v-model="editorData"
                                        :editor-url="editorUrl"
                                ></ckeditor>


                            </CCol>
                        </CRow>
                        <CRow>
                            توضیحات کامل
                            <CCol sm="12">
                                <ckeditor
                                        v-model="editorData_full"
                                        :editor-url="editorUrl"
                                ></ckeditor>


                            </CCol>
                        </CRow>

                        <CRow>

                            <CCol sm="3">
                                <CSelect
                                        :options="currency_items"
                                        :value.sync="selected_currency"
                                        label="واحد پولی"
                                />

                            </CCol>
                        </CRow>
                        <CRow v-show="false">
                            <CCol sm="12">
                                <CTextarea
                                        v-model="seo_summary"

                                        label="سئو توضیحات"

                                />

                            </CCol>
                        </CRow>

                        <CRow>
                            <CCol sm="4">

                                <treeselect
                                        v-model="value_tags"
                                        :multiple="true"
                                        :async="true"
                                        :load-options="load_tags"
                                        placeholder="انتخاب برچسب ها"
                                        :normalizer="normalizer_tags"
                                />


                            </CCol>
                            <CCol sm="4">
                                <treeselect
                                        v-model="value_keywords"
                                        :multiple="true"
                                        :async="true"
                                        :load-options="load_keywords"
                                        placeholder="انتخاب کلمات کلیدی"
                                        :normalizer="normalizer_keywords"
                                />


                            </CCol>


                        </CRow>
                        <hr>
                        <CRow v-show="false">
                            <CCol sm="6">

                                <treeselect
                                        v-model="related_products"
                                        :multiple="true"
                                        :async="true"
                                        :load-options="load_products"
                                        placeholder="محصولات ست"
                                        :normalizer="normalizer_products"
                                />


                            </CCol>
                        </CRow>
                        <hr>

                        <CRow>
<!--                            <CCol sm="4">-->
<!--                                <label>تصویر محصول</label>-->


<!--                                <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>-->


<!--                                <CImg height="150px"-->
<!--                                      width="150px"-->
<!--                                      v-model="previewImage"-->
<!--                                      v-if="previewImage" :src="previewImage"-->
<!--                                />-->
<!--                            </CCol>-->

<!--                            <CCol sm="4">-->
<!--                                <label>ویدئو محصول</label>-->


<!--                                <input type="file" id="video" ref="video" v-on:change="handleVideoUpload()"/>-->
<!--                            </CCol>-->
                            <CCol sm="4">

                                <label>گالری تصویر</label>

                                <vue-upload-multiple-image
                                        @upload-success="uploadImageSuccess"
                                        @before-remove="beforeRemove"
                                        @edit-image="editImage"
                                        :maxImage="10"
                                        :data-images="gallery"

                                ></vue-upload-multiple-image>

                            </CCol>

                        </CRow>
                        <hr>

                        <CRow>
                            <CCol sm="4">
                                <CSelect
                                        label="الگو ویژگی"
                                        :options="property_items"
                                        :value.sync="selected_property"/>

                            </CCol>
                            <CCol sm="4">
                                <label>تصویر الگو</label>


                                <input type="file" id="pattern_image" ref="pattern_image"
                                       v-on:change="handlePatternImageUpload()"/>
                            </CCol>
                        </CRow>
                        <hr>

                        <CRow v-for="(name,index) in product_names" class="border">
                            <CCol sm="4">
                                <CInput
                                        placeholder="نام"
                                        v-model="name.name" />
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                        :options="['fa','en']"
                                        :value.sync="name.lng"/>

                            </CCol>
                            <CCol sm="2">
                               <CButton
                                   outlined
                                   class="mr-1"
                                   @click="product_names.push({lng:'fa',name:''})"
                                   color="dark"
                                   >+</CButton>
                               <CButton
                                       v-if="index!=0"
                                   outlined
                                       class="mr-1"

                                       @click="product_names.splice(index,1)"
                                   color="dark"
                                   >-</CButton>

                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CDataTable
                                        :items="property_group_items"
                                        :fields="fields_properties"

                                        :items-per-page="20"
                                        hover
                                        sorter
                                        pagination
                                >

                                    <template #گروه="{item}">

                                        <td>
                                            <p class="text-muted">{{item.name}}</p>

                                        </td>

                                    </template>

                                    <template #ویژگی="{item}">
                                        <CDataTable
                                                :items="item.items"
                                                :fields="fields_properties_items"
                                                :items-per-page="20"
                                                hover
                                                sorter
                                                pagination
                                        >

                                            <template #عنوان="{item}">

                                                <td>
                                                    <p class="text-muted">{{item.name}}</p>

                                                </td>

                                            </template>

                                            <template #مقدار="{item}">

                                                <td>
                                                    <CInput
                                                            v-model="item.value"
                                                            placeholder="مقدار ویژگی"

                                                    />
                                                </td>

                                            </template>

                                        </CDataTable>


                                    </template>

                                </CDataTable>

                            </CCol>

                        </CRow>
                    </CCardBody>
                    <CCardFooter>
                        <CButton v-if="status_form==0" @click="login()" type="submit" ref="submit_form" size="sm"
                                 color="primary">
                            <CIcon name="cil-check-circle"/>
                            ثبت محصول
                        </CButton>
                        <CButton v-if="status_form!=0" @click="login()" type="submit" ref="submit_form" size="sm"
                                 color="primary">
                            <CIcon name="cil-check-circle"/>
                            ویرایش محصول
                        </CButton>
                    </CCardFooter>
                </CCard>
            </CCol>
        </CRow>

        <CCardBody>

        </CCardBody>


    </div>

</template>

<script>
    import axios from "axios";
    import CKEditor from 'ckeditor4-vue';
    import VueLazyload from 'vue-lazyload'

    Vue.use(CKEditor);
    Vue.use(VueLazyload)
    import VueUploadMultipleImage from 'vue-upload-multiple-image'


    import Vue from "vue";

    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'

    var items_role = [];

    const fields_role = [
        {key: 'نام', _style: 'width:20%'},
        {key: 'دسترسی', _style: 'width:20%'},
    ];

    var items_group = [];


    const fields_group = [
        {key: 'نام', _style: 'width:20%'},
        {key: 'دسترسی', _style: 'width:20%'},


    ];
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'

    const simulateAsyncOperation = fn => {
        setTimeout(fn, 200)
    }

    export default {
        name: 'Login',
        components: {
            Treeselect,
            VueUploadMultipleImage,
            ckeditor: CKEditor.component
        },
        data() {

            return {
                product_names:[{lng:'fa',name:""}],
                editorUrl: "https://furnishium.com/ckeditor/ckeditor.js",
                gallery: [],
                value_category: [],
                value_tags: [],
                value_keywords: [],
                product_images: [],
                related_products: [],
                // define options
                selected_property: 0,
                existence:0,
                warranty:'0',
                property_items: [],
                selected_color: 0,
                colors_items: [],
                selected_brand: 0,
                brand_items: [],
                property_group_items: [],
                property_group_items_product: [],
                fields_properties: [
                    {key: 'گروه', _style: 'width:20%'},
                    {key: 'ویژگی', _style: 'width:80%'},
                ],
                fields_properties_items: [
                    {key: 'عنوان', _style: 'width:20%;display:none'},
                    {key: 'مقدار', _style: 'width:80%;display:none'},
                ],
                image_upload: '',
                options_category: [],
                normalizer_category(node) {
                    return {
                        id: node.cat_id,
                        label: node.name,
                        children: node.subcategories,
                    }
                },
                load_keywords({action, searchQuery, callback}) {

                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            var formData = new FormData();
                            formData.append('search', searchQuery);
                            formData.append('token', localStorage.getItem("token"));

                            axios.post('/api/admin/product_search-keywords', formData, {}).then(function (response) {
                                options = response.data;
                                callback(null, options);
                                // localStorage.setItem("api_token", response.data.access_token);
                                // self.$router.push({ path: 'notes' });
                            })
                                .catch(function (error) {

                                    console.log(error);
                                });


                            //  const options = this.get_keywords(searchQuery);
                            // const options = [1, 2, 3, 4, 5].map(i => ({
                            //     id: `${searchQuery}-${i}`,
                            //     name: `${searchQuery}-${i}`,
                            // }))

                        })
                    }
                },
                normalizer_products(node) {
                    return {
                        id: node.id,
                        label: node.product_title,
                    }
                },
                load_products({action, searchQuery, callback}) {

                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            var formData = new FormData();
                            formData.append('search', searchQuery);
                            formData.append('token', localStorage.getItem("token"));

                            axios.post('/api/admin/search-products', formData, {}).then(function (response) {
                                options = response.data;
                                callback(null, options);
                                // localStorage.setItem("api_token", response.data.access_token);
                                // self.$router.push({ path: 'notes' });
                            })
                                .catch(function (error) {
                                    console.log(error);
                                });


                            //  const options = this.get_keywords(searchQuery);
                            // const options = [1, 2, 3, 4, 5].map(i => ({
                            //     id: `${searchQuery}-${i}`,
                            //     name: `${searchQuery}-${i}`,
                            // }))

                        })
                    }
                },
                normalizer_keywords(node) {
                    return {
                        id: node.keyword_title,
                        label: node.keyword_title,
                    }
                },
                load_tags({action, searchQuery, callback}) {

                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            var formData = new FormData();
                            formData.append('search', searchQuery);
                            formData.append('token', localStorage.getItem("token"));

                            axios.post('/api/admin/product_search-tags', formData, {}).then(function (response) {
                                options = response.data;
                                callback(null, options);
                                // localStorage.setItem("api_token", response.data.access_token);
                                // self.$router.push({ path: 'notes' });
                            })
                                .catch(function (error) {

                                    console.log(error);
                                });


                            //  const options = this.get_keywords(searchQuery);
                            // const options = [1, 2, 3, 4, 5].map(i => ({
                            //     id: `${searchQuery}-${i}`,
                            //     name: `${searchQuery}-${i}`,
                            // }))

                        })
                    }
                },
                normalizer_tags(node) {
                    return {
                        id: node.tag_title,
                        label: node.tag_title,
                    }
                },
                // editor: ClassicEditor,
                editorData: '',
                editorData_full: '',
                editorConfig: {
                    extraPlugins: [],
                    language: 'fa'
                    // The configuration of the editor.
                },
                title: '',
                code: '',
                favorite_url: '',
                seo_title: '',
                summary: '',
                seo_summary: '',
                product_price: '',
                old_price: '',
                tags: '',
                keywords: '',
                file: '',
                video: '',
                pattern_image_file: '',
                selected_currency: 1,
                supplier_price: '',
                currency_items:[],
                previewImage: '',
                image: '',
                group_items: items_group.map((item, id) => {
                    return {...item, id}
                }),
                fields_group,
                role_items: items_role.map((item, id) => {
                    return {...item, id}
                }),
                fields_role,
                details: [],
                collapseDuration: 0,
                status_form: 0,
                options: [
                    {text: 'One', value: 'A'},
                    {text: 'Two', value: 'B'},
                    {text: 'Three', value: 'C'}
                ]
            }
        },
        mounted() {

            this.get_categories();
            this.get_properties();
            this.get_colors();
            this.get_brands();
            this.get_currency_units();
            if (this.$route.params.product_name != null) {
                this.title = this.$route.params.product_name;
            }

        }, watch: {


            'product_price': function () {
                this.product_price= this.product_price.toString().replace(/,/g,'').replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                },
            'old_price': function () {
                this.old_price=  this.old_price.toString().replace(/,/g,'').replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
            'selected_property': function () {
                this.get_property_groups();
            },
            'value_category':function () {
                if(this.$route.params.product_id == null){
                    if(this.options_category.filter(x=>x.subcategories.filter(x=>x.cat_id==this.value_category).length>0).length>0){
                        var cat_name =  this.options_category.filter(x=>x.subcategories.filter(x=>x.cat_id==this.value_category).length>0)[0].cat_code
                        var subcat_name =  this.options_category.filter(x=>x.subcategories.filter(x=>x.cat_id==this.value_category).length>0)[0].subcategories.filter(x=>x.cat_id==this.value_category)[0].cat_code
                        var subcat_count =  this.options_category.filter(x=>x.subcategories.filter(x=>x.cat_id==this.value_category).length>0)[0].subcategories.filter(x=>x.cat_id==this.value_category)[0].product_count
                        var brand_name =  this.brand_items.filter(x=>x.value==this.selected_brand)[0].code
                        subcat_count = parseInt(subcat_count);
                        if(parseInt(subcat_count)<9){
                            subcat_count = "0"+(subcat_count+1).toString()
                        }else{
                            subcat_count =  (subcat_count+1).toString()
                        }
                        this.code = cat_name+"-"+subcat_name+"-"+brand_name+'-'+subcat_count;

                    }
                }



            }
        },
        methods: {
            uploadImageSuccess(formData, index, fileList) {
                console.log('formData', formData)
                console.log('index', index)
                console.log('fileList', fileList)

                this.product_images = fileList;// Upload image api

            },
            beforeRemove(index, done, fileList) {
                console.log('index', index, fileList);
                var r = confirm("remove image");
                // var new_products = [];
                // for (var i = 0; i < this.product_images.length; i++) {
                //     if (i != index) {
                //         new_products.push(this.product_images[i]);
                //     }
                // }
                this.product_images = fileList;
                if (r == true) {
                    done()
                } else {
                }
            },
            editImage(formData, index, fileList) {
                console.log('edit data', formData, index, fileList)
            },
            get_style(color) {
                return {
                    myStyle: {
                        backgroundColor: color
                    }
                }
            },
            editDetails(item) {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = this.items[item.id].name;
                this.color = this.items[item.id].color;
                this.description = this.items[item.id].description;
                this.previewImage = this.items[item.id].image;
                this.status_form = this.items[item.id].cat_id;
                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },
            get_categories() {
                var self = this;
                var formData = new FormData();
                formData.append('token', localStorage.getItem("token"));

                axios.post('/api/product_all-categories', formData, {}).then(function (response) {
                    // console.log("cats is "+response.data.groups);
                    // console.log("cats is "+items);

                    var content_cats = response.data;

                    // items = content_cats.orders;
                    self.options_category = content_cats.data;
                    // console.log("cats is "+items);
                    // self.description = '';
                    // localStorage.setItem("api_token", response.data.access_token);
                    // self.$router.push({ path: 'notes' });
                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_properties() {
                var self = this;
                var formData = new FormData();
                formData.append('token', localStorage.getItem("token"));

                axios.post('/api/admin/get_product_property-templates', formData, {}).then(function (response) {
                    // console.log("cats is "+response.data.groups);
                    // console.log("cats is "+items);

                    var content_cats = response.data;

                    // items = content_cats.orders;
                    self.property_items = [];
                    // console.log("cats is "+items);
                    // self.description = '';
                    var obj = {label: "الگو را انتخاب کنید", value: 0}
                    self.property_items.push(obj);
                    content_cats.tags.forEach((val) => {
                        var obj = {label: val.title, value: val.id}
                        self.property_items.push(obj);
                    });


                    if (self.$route.params.product_id != null) {
                        self.status_form = self.$route.params.product_id;
                        self.get_post_info();
                    }
                    // localStorage.setItem("api_token", response.data.access_token);
                    // self.$router.push({ path: 'notes' });
                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_property_groups() {
                var self = this;
                var formData = new FormData();
                formData.append('token', localStorage.getItem("token"));
                formData.append('property_id', self.selected_property);

                axios.post('/api/admin/get_product_property-groups-items', formData, {}).then(function (response) {
                    // console.log("cats is "+response.data.groups);
                    // console.log("cats is "+items);

                    var content_cats = response.data;

                    // items = content_cats.orders;
                    if (content_cats.error == 0) {
                        self.property_group_items = content_cats.tags;
                        console.log("sadsd " + " " + self.property_group_items)

                        self.property_group_items.forEach((val) => {
                            console.log("sadsd " + " " + val.items)

                            val.items.forEach((val_items) => {
                                console.log("sadsd " + " " + val_items.id)

                                self.property_group_items_product.forEach((val_product) => {
                                    console.log("sadsd " + val_product.property_key_id + " " + val_items.id)
                                    if (val_product.property_key_id == val_items.id) {
                                        val_items.value = val_product.property_value
                                    }
                                });
                            });
                        });
                    } else {
                        self.property_group_items = [];

                    }
                    // console.log("cats is "+items);
                    // self.description = '';
                    // localStorage.setItem("api_token", response.data.access_token);
                    // self.$router.push({ path: 'notes' });
                })
                    .catch(function (error) {

                        self.property_group_items = [];

                        console.log(error);
                    });

            },

            get_keywords(search) {
                var self = this;
                var formData = new FormData();
                formData.append('token', localStorage.getItem("token"));
                formData.append('search', search);

                axios.post('/api/admin/product_search-keywords', formData, {}).then(function (response) {
                    return response.data
                    // localStorage.setItem("api_token", response.data.access_token);
                    // self.$router.push({ path: 'notes' });
                })
                    .catch(function (error) {

                        console.log(error);
                    });


            },
            get_post_info() {
                var self = this;
                var formData = new FormData();
                formData.append('token', localStorage.getItem("token"));
                formData.append('product_id', self.status_form);

                axios.post('/api/admin/get_product_info', formData, {}).then(function (response) {
                    var post_data = response.data;

                    self.previewImage = post_data.post.image;
                    post_data.post.categories.forEach((val) => {
                        self.value_category.push(val.cat_id);
                    });
                    post_data.post.tags.forEach((val) => {
                        self.value_tags.push(val.name);
                    });
                    post_data.post.keywords.forEach((val) => {
                        self.value_keywords.push(val.name);
                    });
                    // self.value_category = post_data.post.categories;
                    //  self.options_=post_data.post.tags;
                    // self.value_keywords=post_data.post.keywords;
                    self.selected_property = parseInt(post_data.post.properties_group);
                    self.title = post_data.post.title;
                    self.code = post_data.post.code;
                    self.favorite_url = post_data.post.favorite_url;
                    self.editorData = post_data.post.summary;
                    self.existence = post_data.post.existence;
                    self.warranty = post_data.post.warranty;


                    self.editorData_full = post_data.post.full_summary;
                    self.seo_summary =  post_data.post.summary
                    if (post_data.post.color.length > 0) {
                        self.selected_color = parseInt(post_data.post.color[0].color_id);
                    }
                    self.selected_brand = parseInt(post_data.post.brand_id);

                    self.seo_title = post_data.post.seo_title;
                    self.property_group_items_product = post_data.post.properties;
                    if (post_data.post.price != null) {
                        self.product_price = post_data.post.price[0].price;
                        self.old_price = post_data.post.price[0].old_price;
                        self.supplier_price = post_data.post.price[0].supplier_price;
                        self.selected_currency = post_data.post.price[0].currency_id;
                        if(self.old_price==null){
                            self.old_price = "";
                        }
                    }
                    self.product_names=[{lng:'fa',name:""}]
                    if(post_data.post.names.length>0){
                        self.product_names = []
                    }
                    post_data.post.names.forEach(function (val) {

                        if(val.is_master=='0'){
                            self.product_names.push({lng:val.lng_id,name:val.name});
                        }
                    })
                    post_data.post.gallery.forEach((val2) => {
                        var item_obj = {path: val2.product_image, name: val2.image}
                        self.gallery.push(item_obj);
                        self.product_images.push({path: val2.product_image, default: 1})
                    });
                    // localStorage.setItem("api_token", response.data.access_token);
                    // self.$router.push({ path: 'notes' });
                }).catch(function (error) {
                    console.log(error);
                });


            },


            goRegister() {
                this.$router.push({path: 'register'});
            },
            goSubCategories(item, index) {

                this.$router.push({path: '/categories/' + this.items[index].cat_id});
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
            get_colors() {
                var self = this;
                var formData = new FormData();
                formData.append('token', localStorage.getItem("token"));

                axios.post('/api/get_product_colors', formData, {}).then(function (response) {

                    var content_cats = response.data;

                    // items = content_cats.orders;
                    // self.colors_items = content_cats;
                    self.colors_items.push({label: "انتخاب کنید", value: 0})

                    content_cats.forEach(function (val) {
                        self.colors_items.push({label: val.name, value: val.id})
                    })
                    // console.log("cats is "+items);
                    // self.description = '';
                    // localStorage.setItem("api_token", response.data.access_token);
                    // self.$router.push({ path: 'notes' });
                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_brands() {
                var self = this;
                var formData = new FormData();
                formData.append('token', localStorage.getItem("token"));

                axios.post('/api/admin/get_brands', formData, {}).then(function (response) {

                    var content_cats = response.data;

                    // items = content_cats.orders;
                    // self.colors_items = content_cats;
                    self.brand_items.push({label: "انتخاب کنید", value: 0,code:''})

                    content_cats.forEach(function (val) {
                        self.brand_items.push({label: val.name, value: val.id,code:val.code})
                    })
                    // console.log("cats is "+items);
                    // self.description = '';
                    // localStorage.setItem("api_token", response.data.access_token);
                    // self.$router.push({ path: 'notes' });
                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_currency_units() {
                var self = this;
                var formData = new FormData();
                formData.append('token', localStorage.getItem("token"));

                axios.post('/api/admin/get_currency_units', formData, {}).then(function (response) {

                    var content_cats = response.data;

                    // items = content_cats.orders;
                    // self.colors_items = content_cats;
                    self.currency_items.push({label: "انتخاب کنید", value: 0,code:''})

                    content_cats.forEach(function (val) {
                        self.currency_items.push({label: val.CurrencyName, value: val.id})
                    })
                    // console.log("cats is "+items);
                    // self.description = '';
                    // localStorage.setItem("api_token", response.data.access_token);
                    // self.$router.push({ path: 'notes' });
                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            handleFileUpload() {
                this.file = this.$refs.file.files[0];
                var input = event.target;
                // Ensure that you have a file before attempting to read it
                if (input.files && input.files[0]) {
                    // create a new FileReader to read this image and convert to base64 format
                    var reader = new FileReader();
                    // Define a callback function to run, when FileReader finishes its job
                    reader.onload = (e) => {
                        // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                        // Read image as base64 and set to imageData
                        this.previewImage = e.target.result;
                    }
                    // Start the reader job - read file as a data url (base64 format)
                    reader.readAsDataURL(input.files[0]);
                }
            },
            handlePatternImageUpload() {
                this.pattern_image_file = this.$refs.pattern_image.files[0];
                var input = event.target;
                // Ensure that you have a file before attempting to read it
                if (input.files && input.files[0]) {
                    // create a new FileReader to read this image and convert to base64 format
                    var reader = new FileReader();
                    // Define a callback function to run, when FileReader finishes its job
                    reader.onload = (e) => {
                        // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                        // Read image as base64 and set to imageData
                        // this.previewImage = e.target.result;
                    }
                    // Start the reader job - read file as a data url (base64 format)
                    reader.readAsDataURL(input.files[0]);
                }
            },
            handleVideoUpload() {
                this.video = this.$refs.video.files[0];
                var input = event.target;
                // Ensure that you have a file before attempting to read it
                // if (input.files && input.files[0]) {
                // create a new FileReader to read this image and convert to base64 format
                // var reader = new FileReader();
                // // Define a callback function to run, when FileReader finishes its job
                // reader.onload = (e) => {
                //     // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                //     // Read image as base64 and set to imageData
                //     this.previewImage = e.target.result;
                // }
                // Start the reader job - read file as a data url (base64 format)
                // reader.readAsDataURL(input.files[0]);
                // }
            },
            login() {


                let self = this;
                const formData = new FormData()
                let url;
                if (self.status_form == 0) {
                    url = "/api/admin/product";
                } else {
                    url = "/api/admin/product/update";
                    formData.append('post_id', this.status_form)

                }

                console.log("product images", this.product_images)
                for (var i = 0; i < this.product_images.length; i++) {
                    formData.append('post_images[]', this.product_images[i].path)
                }
                formData.append('related_products', JSON.stringify(this.related_products));
                formData.append('property_group_items', JSON.stringify(this.property_group_items));
                formData.append('post_image', this.file);
                formData.append('form_post_cat_list', this.value_category);
                formData.append('form_post_tags', this.value_tags);
                formData.append('form_post_keywords', this.value_keywords);
                formData.append('form_post_name', this.title);
                formData.append('form_post_url', this.favorite_url);
                formData.append('code', this.code);
                formData.append('is_potential', 1);
                formData.append('form_post_text', this.editorData);
                formData.append('form_post_full_text', this.editorData_full);
                formData.append('form_post_meta_desc', this.editorData);
                formData.append('form_post_meta_title', this.seo_title);
                formData.append('form_post_meta_price',0);
                formData.append('old_price', 0);
                formData.append('supplier_price', 0);
                formData.append('product_video', this.video);
                formData.append('pattern_image_file', this.pattern_image_file);
                formData.append('selected_currency', this.selected_currency);

                if (this.selected_color != 0) {
                    formData.append('product_color', this.selected_color);

                }
                formData.append('brand_id', this.selected_brand);
                formData.append('existence', this.existence);
                formData.append('warranty', this.warranty);

                formData.append('token', localStorage.getItem("token"));
                formData.append('product_names', JSON.stringify(this.product_names));

                // formData.append('is_admin', 1)
                // formData.append('role_group', this.selected_group)
                // formData.append('roles', self.$refs.permissions)
                axios.post(url, formData, {}).then((res) => {
                    console.log(res)
                    self.$root.modal_component.show_api_response_modals(res);
                    if (self.status_form == 0 && self.$route.params.product_name == null) {
                        self.name = '';
                        self.mobile = '';
                        self.email = '';
                        self.description = '';
                        self.password = '';
                        self.product_price = '';
                        self.old_price = '';
                        self.supplier_price = '';
                        self.selected_property = '0';
                        self.permissions = [];
                    } else {
                        self.$router.go(-1)
                    }

                }).catch(function (error) {
                    console.log(error);
                });

            }
        }
    }


</script>
<style>

</style>
